<h2>{{title}}</h2>

<body>
    <div class="wrapper">
        <div id="cart">
            <div id="cart-list" *ngIf='items.length > 0'>
                <table>
                    <thead>
                        <tr>
                            <th>Meal</th>
                            <th>Price</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tr *ngFor='let item of items'>
                        <td>{{item.main}}</td>
                        <td>{{item.price | currency:currencyCode:'symbol'}}</td>
                        <td>{{getQuantity()}}</td>
                    </tr>
                    <br />
                    <tr>
                        <td>Total: </td>
                        <td>{{priceTotal() | currency:currencyCode:'symbol'}}</td>
                    </tr>
                </table>
                <br />
                <button id="checkout-btn" (click)="popup = true">Checkout</button>
            </div>
            <div id="empty" *ngIf='items.length == 0'>
                <h3>No items in cart!</h3>
            </div>
            <div class="overlay" *ngIf="popup">
                <div class="popup">
                    <h2>Thank you for your business!</h2>
                    <a class="close" (click)="checkout()">&times;</a>
                </div>
            </div>
            <br />
            <a routerLink="/menu">Back to Menu</a>
        </div>
    </div>
</body>